import { jsx, jsxs } from "react/jsx-runtime";
import { useContext } from "react";
import PropTypes from "prop-types";
import { DropdownMenu } from "../dropdown-menu/dropdown-menu.es.js";
import { DropdownMenuButton } from "../dropdown-menu/dropdown-menu-button.es.js";
import "../dropdown-menu/dropdown-menu-item.es.js";
import "../dropdown-menu/dropdown-menu-link.es.js";
import { DropdownMenuList } from "../dropdown-menu/dropdown-menu-list.es.js";
import "../dropdown-menu/dropdown-menu-section.es.js";
import "../dropdown-menu/dropdown-menu-context.es.js";
import "../dropdown-menu/dropdown-menu-separator.styles.es.js";
import "../dropdown-menu/dropdown-menu-text.es.js";
import { UtilityButton } from "../utility-button/utility-button.es.js";
import { CardMenuWrapper } from "./card-menu.styles.es.js";
import { cardContext } from "./card-context.es.js";
const propTypes = {
  alwaysExpanded: PropTypes.bool,
  children: PropTypes.node.isRequired,
  disabled: PropTypes.bool,
  variant: PropTypes.oneOf(["concealed", "standard"])
};
const defaultProps = {
  alwaysExpanded: false,
  disabled: false,
  variant: "standard"
};
const CardMenu = ({ alwaysExpanded, children, disabled, variant }) => {
  const { hasHover, hasFocus } = useContext(cardContext);
  return /* @__PURE__ */ jsx(DropdownMenu, { justify: "end", children: ({ isExpanded }) => (variant !== "concealed" || hasHover || hasFocus || isExpanded) && /* @__PURE__ */ jsxs(CardMenuWrapper, { variant, children: [
    /* @__PURE__ */ jsx(
      DropdownMenuButton,
      {
        as: UtilityButton,
        disabled,
        icon: "ellipsis",
        magnitude: "small"
      }
    ),
    /* @__PURE__ */ jsx(
      DropdownMenuList,
      {
        alwaysExpanded,
        offset: variant === "concealed" ? 8 : 4,
        children
      }
    )
  ] }) });
};
CardMenu.propTypes = propTypes;
CardMenu.defaultProps = defaultProps;
export {
  CardMenu
};
